<template>
  <div class="guidePage">
    <div class="main">
      <h1>您好！很高兴认识您！</h1>
      <p class="txt1">
        为了使您可以更好的体验 <br />
        SPR工具为您带来的工作上的便利；
      </p>
      <p class="txt2">请配合完善以下个人信息，谢谢！</p>
    </div>
    <div class="from_wrapper">
      <div class="from">
        <div class="input_box">
          <span class="mark">*</span>
          <van-field v-model="form.truename" placeholder="请输入姓名" />
        </div>
        <div class="input_box">
          <span class="mark">*</span>
          <van-field
            v-model="form.mobile"
            placeholder="请输入注册企业微信时相同的手机号"
          />
        </div>
        <div class="input_box vifity_code flex-between">
          <span class="mark">*</span>
          <van-field v-model="form.code" placeholder="输入短信验证码"  @keyup.enter="handleQuery"  />
          <div
            class="vifity_btn flex-rowc"
            :class="{ disable: isDisable }"
            @click="handleSendVifity"
          >
            {{ countText }}
          </div>
        </div>
      </div>
      <div class="agree_wrapper flex-rowl">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#F62560"
          class="check"
        />
        <div class="txt">
          <p>你已阅读并充分理解，WINK SShoWP SPR的</p>
          <agree></agree>
          <p>
            确认同意，允许WINK SShoWP在相关服务流程中，
            对你的个人信息进行收集和使用
          </p>
        </div>
      </div>
      <div class="custom_btn query" @click="handleQuery">
        确认 <i class="iconfont icon-yuyinjiantou"></i>
      </div>
    </div>

    <van-overlay :show="isShow" @click="isShow = false"> </van-overlay>
    <div class="popup_box" v-if="isShow" @click.self="isShow = false">
      <div class="popup_wrapper">
        <div class="popup_header flex-between">
          <div class="tit">请完成安全验证</div>
          <van-icon name="cross" @click="isShow = false" />
        </div>
        <div class="popup_content flex-rowc">
          <div class="verify-wrap">
            <Verify
              :type="3"
              :barSize="barSize"
              :showButton="false"
              @success="successVerify"
              @error="erroeVerify"
            ></Verify>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendVerfity, getUserInfo } from "../api/api";
import { updateUserNameTel } from "../api/user";
import Verify from "vue2-verify";
import agree from "../components/Agreement.vue";
export default {
  name: "guide",
  components: { Verify, agree },
  data() {
    return {
      form: {
        truename: "",
        mobile: "",
        code: "",
      },
      checked: false,
      isDisable: false,
      countText: "获取验证码",
      isShow: false,
      barSize: {
        width: "100%",
        height: "40px",
      },
      isVerify: false, // 是否验证成功
    };
  },
  methods: {
    // 拖动滑块成功
    successVerify(obj) {
      this.isVerify = true;
      this.code = "";
      this.verfity(obj);
    },
    // 拖动滑块失败
    erroeVerify(obj) {
      this.verify = false;
      this.code = "";
      obj.refresh();
    },
    // 发送验证码
    verfity(obj) {
      let params = {
        cellphone: this.form.mobile,
        screen: "维应企微SPR移动端改手机号和姓名", // 3-维应企微SPR开发版移动端改手机号和姓名 | 2003-维应企微SPR移动端改手机号和姓名
      };
      // 关闭验证弹窗 start
      obj.refresh();
      this.isVerify = false;
      this.isShow = false;
      // 关闭验证弹窗 end
      const Toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "发送中，请稍后...",
      });
      let i = 60;
      sendVerfity(params)
        .then((res) => {
          if (res.result) {
            // this.isShow = false;
            const timer = setInterval(() => {
              i--;
              if (i <= 0) {
                this.countText = `重发验证码`;
                this.isDisable = false;
                clearInterval(timer);
              } else {
                this.countText = `重发验证码（${i--}）s`;
                this.isDisable = true;
              }
            }, 1000);
            // this.$toast.success(res.msg);
          } else {
            this.$toast.fail(res.msg || "服务器报错，请稍后～");
          }
          Toast.clear();
          // 重置滑块
          // setTimeout(() => {

          // }, 500);
        })
        .catch((err) => {
          Toast.clear();
          this.$toast.fail(err.mess || "服务器报错，请稍后～");
          // obj.refresh();
          // this.isVerify = false;
          // this.isShow = false
        });
    },

    // 验证码
    handleSendVifity() {
      let { isDisable, isVerify } = this;
      let tel = this.form.mobile;
      if (isDisable) return;
      let photoReg = /^1[3-9]\d{9}$/;
      if (tel == "") {
        this.$toast("请输入手机号！");
        return;
      } else if (!photoReg.test(tel)) {
        this.$toast("请输入正确的手机号！");
        return;
      }
      if (!isVerify) {
        // this.$toast("请向右滑完成验证");
        this.isShow = true;
        return;
      }
    },

    // 确认提交
    handleQuery() {
      let { checked, form } = this;
      let { truename, mobile, code } = this.form;
      if (truename == "") {
        this.$toast("请输入姓名！");
        return;
      }
      if (mobile == "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (code == "") {
        this.$toast("请输入短信验证码！");
        return;
      }
      if (!checked) {
        this.$toast("请选择阅读条款！");
        return;
      }
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      form.openid = this.$store.state.OPENID;
      updateUserNameTel(form).then((res) => {
        toast.clear();
        if (res.result) {
          this.$toast.success(res.msg);
          this.getUserInfo();
        } else {
          this.$toast.fail(res.msg || "接口失效，请稍后～");
        }
      });
    },
    getUserInfo() {
      getUserInfo({ openid: this.$store.state.OPENID }).then((res) => {
        this.$store.commit("updateUserInfo", res);
        this.$store.commit("setUserLoginType", 1);
        setTimeout(() => {
          this.$router.push("/home");
        }, 1500);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.guidePage {
  .main {
    padding: 130px 50px 0 100px;
    font-size: 26px;
    color: #333333;
    h1 {
      font-size: 36px;
    }
    .txt1 {
      margin: 70px 0 30px;
    }
    .txt2 {
      color: #f40039;
      font-size: 36px;
    }
    p {
      line-height: 38px;
    }
  }
  .from_wrapper {
    background: #fff;
    padding: 69px 75px 86px;
    .tit {
      font-size: 24px;
      color: #333333;
      margin-bottom: 60px;
      .iconfont {
        font-size: 46px;
        margin-right: 20px;
      }
    }
    .from {
      .input_box {
        background: #f0f0f0;
        position: relative;
        border: none;
        margin-bottom: 30px;
        padding: 0 70px 0 33px;
        font-size: 20px;
        .mark {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -25px;
          font-size: 35px;
          color: #f62560;
        }
        &.vifity_code {
          padding-right: 2px;
          .vifity_btn {
            height: 95%;
            background: #fff;
            font-size: 20px;
            color: #373737;
            border-radius: 45px;
            white-space: nowrap;
            padding: 0 30px;
            &.disable {
              background: #ccc;
            }
          }
        }
        .visual {
          position: absolute;
          top: 50%;
          right: 30px;
          transform: translateY(-50%);
          .iconfont {
            font-size: 38px;
            color: #818181;
          }
        }
      }
    }
    .btn {
      width: 280px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background: #f62560;
      border-radius: 25px;
      font-size: 20px;
      color: #fff;
      margin: 70px auto 0;
    }
    .content {
      font-size: 30px;
      color: #333333;
      text-align: center;
      padding: 106px 0;
      .icon {
        width: 75px;
        height: 75px;
        margin: 0 auto 48px;
      }
    }
    .agree_wrapper {
      padding: 40px 20px 0;
      font-size: 20px;
      color: #1e1e1e;
      align-items: flex-start;
      .check {
        margin-right: 15px;
        flex-shrink: 0;
      }
      .txt {
        p {
          line-height: 30px;
          &:last-child {
            margin-top: 20px;
          }
        }
      }
    }
  }
  .custom_btn {
    margin-top: 120px;
  }
  .verify-wrap {
    width: 500px;
    font-size: 20px;
  }
  .popup_box {
    height: 100vh;
    top: 0;
    position: fixed;
    z-index: 999999999999;
    width: 100%;
    .popup_wrapper {
      width: 550px;
      box-sizing: border-box;
      background: #fff;
      top: 34%;
      margin: auto;
      position: relative;
      z-index: 9999999999;
      .popup_header {
        height: 110px;
        padding: 0 20px;
        font-size: 32px;
        box-sizing: border-box;
      }
      .popup_content {
        padding: 25px 0 70px;
        position: relative;
      }
    }
  }
}
</style>